import { WorkflowContext, Metadata, EventsRecords, SessionIdentity } from '@samelogic/steps';
import { SessionManager } from '../../tracking/sessions';

/**
 * Context is a container for the current state of the workflow.
 * It is passed to each step in the workflow.
 * It is used to store state and manage `onComplete` events.
 */
export class Context implements WorkflowContext {
  constructor(
    private readonly sessionManager: SessionManager,
    public readonly metadata: Metadata,
    public readonly events: EventsRecords
  ) {
    this.identity = this.sessionManager.getSessionIdentity();

    this.sessionManager.onChanged.subscribe((_, ev) => {
      if (ev.property === 'identity') {
        this.identity = ev.value;
      }
    });
  }

  public identity: SessionIdentity;

  public clone(events?: EventsRecords): Context {
    const clone = new Context(this.sessionManager, this.metadata, events || this.events);
    return clone;
  }
}
